import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {
  alabaster,
  cloudLight,
  ravenBlack,
  silverChalice,
} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 10,
  },
  listItem: {
    backgroundColor: alabaster,
    borderRadius: 12,
    marginBottom: 10,
    paddingLeft: indent,
    paddingRight: indent * 0.35,
  },
  orderDateText: {
    color: ravenBlack,
    fontSize: 15,
    fontWeight: '600',
    lineHeight: 21,
    paddingBottom: 2,
  },
  orderNumberText: {
    color: codGray,
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 21,
    paddingTop: 2,
    paddingBottom: 4,
  },
  orderMetaText: {
    color: ravenBlack,
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 18,
    paddingTop: 2,
  },
  viewMoreOrders: {
    borderTopColor: cloudLight,
  },
  viewMoreOrderButton: {
    height: 52,
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrowIcon: {
    color: silverChalice,
    fontSize: 18,
    paddingLeft: indent * 0.675,
    alignSelf: 'center',
  },
  orderHistoryList: {
    flexDirection: 'row',
  },
});
